<template>
	<div>
		<div class="common_box_tit">
			<div>课程ppt</div>
			<div class="bom_line"></div>
		</div>
		<div class="pxxy">
			<div v-for="(it,i) in pptList" :key="i" @click="lookPpt(it)">
				<div class="iconfont icon-_kecheng"></div>
				<div>{{it.name}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getResourcese
	} from '@/api/home/guild'
	export default {
		components: {

		},
		data() {
			return {
				pptList: [],
			}

		},
		mounted() {
			this.getResourcesePPT();
		},
		methods: {
			getResourcesePPT() {
				getResourcese({
					type: 6,
				}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.pptList = res.result;
					}
				})
			},
			lookPpt(it){
				window.open('http://view.officeapps.live.com/op/view.aspx?src='+it.resource)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pxxy {
		display: flex;
		// justify-content: space-between;
		align-items: center;
		margin-top: 20px;
		margin-bottom: 30px;
	
		>div {
			width: 175px;
			height: 245px;
			margin: 10px;
			border-radius: 8px;
			background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #1F2C45;
			box-shadow: 0px 6px 40px 0px rgba(31, 44, 69, 0.1);
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			font-size: 14px;
			transition: all 0.22s ease-in;
			-webkit-transition: all 0.22s ease-in;
			-moz-transition: all 0.22s ease-in;
			-o-transition: all 0.22s ease-in;
			cursor: pointer;
	
			.iconfont {
				color: #4D6BCB;
				font-size: 45px;
			}
		}
	
		>div:hover {
			transform: scale(1.05);
			color: #fff;
			background: linear-gradient(270deg, #2D85E2 2%, #5B43DF 100%);
			box-shadow: 0px 6px 40px 0px rgba(31, 44, 69, 0.1);
	
			.iconfont {
				color: #fff;
			}
		}
	}
</style>
